module.exports = __webpack_public_path__ + "img/c01_unittechpeltastchampion_Normal_ua.596b6d8a.webp";